import { TYPES } from "./bailiff_dialog.type";

const initState = {
  bailiffDialogAll: null,
  bailiffDialogOpenAdd: false,
  bailiffDialogOpenEdit: false,
  bailiffDialogSelected: [],
  bailiffDialogSearch: "",
  //
  bailiffDialogUrlAudio: null,
  bailiffDialogPlay: false,
  bailiffDialogSecond: 0,
  bailiffDialogSlot: 0,
  bailiffDialogGap: 0,
  bailiffDialogKick: null,
  //
  bailiffDialogOpenSplit: false,
  bailiffDialogOptionSpeaker: [],
  //
  bailiffDialogPreview: null,
  bailiffDialogMergedRaw: [],
  bailiffDialogDraftEdited: [],
};

const bailiffDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_BAILIFF_DIALOG_ALL:
      return {
        ...state,
        bailiffDialogAll: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_OPEN_ADD:
      return {
        ...state,
        bailiffDialogOpenAdd: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_OPEN_EDIT:
      return {
        ...state,
        bailiffDialogOpenEdit: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SELECTED:
      return {
        ...state,
        bailiffDialogSelected: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SEARCH:
      return {
        ...state,
        bailiffDialogSearch: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_URL_AUDIO:
      return {
        ...state,
        bailiffDialogUrlAudio: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SECOND:
      return {
        ...state,
        bailiffDialogSecond: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_PLAY:
      return {
        ...state,
        bailiffDialogPlay: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SLOT:
      return {
        ...state,
        bailiffDialogSlot: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_GAP:
      return {
        ...state,
        bailiffDialogGap: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_OPEN_SPLIT:
      return {
        ...state,
        bailiffDialogOpenSplit: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_OPTION_SPEAKER:
      return {
        ...state,
        bailiffDialogOptionSpeaker: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_PREVIEW:
      return {
        ...state,
        bailiffDialogPreview: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_KICK:
      return {
        ...state,
        bailiffDialogKick: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_MERGED_RAW:
      return {
        ...state,
        bailiffDialogMergedRaw: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_DRAFT_EDITED:
      return {
        ...state,
        bailiffDialogDraftEdited: payload,
      };

    default:
      return state;
  }
};

export default bailiffDialogReducer;
